import React, { useState } from 'react';
import { Typography, Box, IconButton, Grid, Button } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
// import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import axiosInstance from '../../../utils/axios';
import { Wrapper } from '../../../sections/@dashboard/Trade/watchlist/BuyScriptDrawer';

const ResetAccountModal = ({ client, open, onClose, onUserUpdate }) => {
  //   const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleResetAccount = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.put(`/trade/reset-account/${client._id}`);
      enqueueSnackbar(response.data.message, { variant: 'success' });
      setIsLoading(false);
      onUserUpdate();
      onClose();
    } catch (err) {
      setIsLoading(false);
      onClose();
      enqueueSnackbar(err.message, { variant: 'error' });
    }
  };

  return (
    <Wrapper
      open={open}
      onClose={onClose}
      children={
        <Box width={{ xs: '100%', sm: '350px' }} marginX={'auto'}>
          <IconButton sx={{ position: 'absolute', top: 0, right: 0 }} onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h4" textAlign="center" pb={2}>
            {`Reset Account`}
          </Typography>
          <Typography variant="body1" textAlign="center" pb={2}>
            Are you sure you want to Reset this account?
          </Typography>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <LoadingButton
                variant="contained"
                fullWidth
                size="large"
                onClick={handleResetAccount}
                color="primary"
                loading={isLoading}
              >
                Yes
              </LoadingButton>
            </Grid>
            <Grid item xs={6}>
              <Button variant="outlined" fullWidth size="large" onClick={onClose}>
                No
              </Button>
            </Grid>
          </Grid>
        </Box>
      }
    />
  );
};

ResetAccountModal.propTypes = {
  client: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUserUpdate: PropTypes.func,
};

export default ResetAccountModal;
